import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = ["open"]
const _hoisted_2 = ["value"]
const _hoisted_3 = { class: "actions" }
const _hoisted_4 = ["disabled"]

import { ref } from 'vue';
import { request } from '@/admin/shared/api/httpClient';


export default /*@__PURE__*/_defineComponent({
  __name: 'GrantGroupDialog',
  props: {
    open: { type: Boolean },
    userId: { type: Function }
  },
  emits: ["close", "done"],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emit = __emit;

const groups = [
    'admin.dashboard', 'admin.support', 'admin.finance', 'admin.mentors',
    'admin.users', 'admin.consultations', 'admin.commerce', 'admin.events',
    'admin.reviews', 'admin.notifications', 'admin.conferences',
];
const group = ref('');
const busy = ref(false);

async function submit(): Promise<void> {
    busy.value = true;
    try {
        await request({
            method: 'post',
            url: `/admin-api/users/${props.userId()}/grant-admin-group/`,
            data: { group: group.value },
        });
        emit('done');
    } finally {
        busy.value = false;
    }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("dialog", {
    open: _ctx.open,
    class: "action-dialog"
  }, [
    _cache[4] || (_cache[4] = _createElementVNode("h3", null, "Дать admin-группу", -1)),
    _createElementVNode("label", null, [
      _cache[3] || (_cache[3] = _createTextVNode("Группа ")),
      _withDirectives(_createElementVNode("select", {
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((group).value = $event))
      }, [
        _cache[2] || (_cache[2] = _createElementVNode("option", { value: "" }, "— Выберите —", -1)),
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(groups, (g) => {
          return _createElementVNode("option", {
            key: g,
            value: g
          }, _toDisplayString(g), 9, _hoisted_2)
        }), 64))
      ], 512), [
        [_vModelSelect, group.value]
      ])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("button", {
        class: "btn btn--primary",
        disabled: !group.value || busy.value,
        onClick: submit
      }, _toDisplayString(busy.value ? 'Назначаю…' : 'Дать группу'), 9, _hoisted_4),
      _createElementVNode("button", {
        class: "btn",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('close')))
      }, "Отмена")
    ])
  ], 8, _hoisted_1))
}
}

})